module.exports = __webpack_public_path__ + "img/psoccltbm785r2nms44bobj14slpkdz1w92969298b9-99c7-4a1f-9518-d49688b9eb29.c1432ba7.png";